enum ProposalState {
  DRAFT = "DRAFT",
  NEW_GIG = "NEW_GIG",
  OPEN_BID = "OPEN_BID",
  /** @deprecated */
  AWAITING_CHEF_CONFIRMATION = "AWAITING_CHEF_CONFIRMATION",
  ACCEPTED_BOOKED = "ACCEPTED_BOOKED",
  INVOICE_CHANGE = "INVOICE_CHANGE",
  FINISHED_AND_PAID = "FINISHED_AND_PAID",
  COMPLETED = "COMPLETED",
  DEPOSIT_PAID = "DEPOSIT_PAID",
  PAID = "PAID",
  PENDING = "PENDING",
  /** @deprecated */
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  CANCELED_GIG = "CANCELED_GIG",
}

export default ProposalState;
